/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import getWindow from './helpers/getWindow';
import userAgentParser from './helpers/userAgentParser';
import urlParser from './helpers/urlParser';
import getCookieByName from './helpers/cookies';
import localStorage from './helpers/localStorage';

const window = getWindow();

export class PayloadBuilder {
    constructor({
        windowInterface,
        localStorageInterface,
        urlParserInterface,
        userAgentParserInterface,
    }) {
        this.localStorage = localStorageInterface;
        this.urlParser = urlParserInterface;
        this.userAgentParser = userAgentParserInterface;
        this.window = windowInterface;

        this.appName = this.window ? 'mbp-pwa-client' : 'mbp-pwa-node';
        this.appSource = this.window ? 'browser' : 'node';
    }

    fromParamObj = (paramObj) => {
        if (!paramObj) {
            return {
                message: 'no logging information provided',
            };
        }
        const isSSR = typeof window === 'undefined';

        // Destructure message param to exclude from console log params
        const {
            message,
            error,
            jsError,
            errorMessage,
            stack,
            severity,
            requestUrl,
            requestUserAgentString,
            ...consoleLogParams
        } = paramObj;

        // TODO add ga id

        const userAgent = this.userAgentParser.parse(requestUserAgentString);
        const url = this.urlParser.parse(requestUrl);

        // cookies
        const shopperManager = getCookieByName('ShopperManagerEnterprise');

        // pageType
        const { pageType } = this.window || {};

        // localstorage
        // localstorage returns null for bad vals, default to undefined
        const enterpriseId = this.localStorage.get('enterpriseId') || undefined;

        const payload = {
            ...consoleLogParams,
            app: this.appName,
            severity,
            message: `mbpLogger ${message}`,
            error: {
                kind: severity,
                message: errorMessage,
                stack,
            },
            source: this.appSource,
            enterpriseId,
            shopperManager,
            http: {
                url: url.url || undefined,
                url_details: {
                    host: url.host || undefined,
                    path: url.path || undefined,
                    queryString: url.queryString || undefined,
                },

                useragent: userAgent.ua || undefined,
                useragent_details: {
                    os: {
                        family: userAgent.os || undefined,
                    },
                    browser: {
                        family: userAgent.browser || undefined,
                    },
                    device: {
                        family: userAgent.device || undefined,
                    },
                },
            },
            pageType,
        };

        return payload;
    }
}

const payloadBuilder = new PayloadBuilder({
    windowInterface: window,
    localStorageInterface: localStorage,
    urlParserInterface: urlParser,
    userAgentParserInterface: userAgentParser,
});

export default payloadBuilder;
